import { gql, useQuery } from '@apollo/client';
import { BRAND_CATEGORY_FRAGMENT } from '../../pages/SlideshowEdit/CategorySelector/getBrandCategories.web.graphql';
import {
  GetBrandKeysQuery,
  GetBrandKeysQueryVariables,
} from '../../__generated__/queries-web';

const GET_BRANDKEYS = gql`
  query GetBrandKeys($first: UnsignedInt!, $level: UnsignedInt!) {
    categories(where: { level: $level, format: Category }, first: $first) {
      ...BrandCategoryFragment
      brandKey
    }
  }
  ${BRAND_CATEGORY_FRAGMENT}
`;

export const useGetBrandKey = () =>
  useQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GET_BRANDKEYS, {
    variables: {
      first: 100,
      level: 2,
    },
  });
